import React from "react";
import styled from "styled-components";
import Countdown from "./Countdown";

const StyledSection = styled.section`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 3%;
  font-size: 20px;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    /* flex-flow: row; */
    /* grid-template-columns: repeat(3, 1fr); */
    font-size: 24px;
  }
`;
const CountDowns = (props) => {
  const data = [
    {
      images: props.images,
      target: 1667,
      suffix: " units",
      imageName: "countdown_01",
      text: "No. of single-use plastic products bought per household:",
    },
    {
      images: props.images,
      target: 48.5,
      suffix: " kg.",
      imageName: "countdown_02",
      text: "Total weight of single-use plastic waste per household:",
    },
    {
      images: props.images,
      target: 1544760,
      suffix: " kg.",
      imageName: "countdown_03",
      text: "The weight of all UK households' annual single-use plastic waste:",
    },
  ];

  return (
    <StyledSection>
      {data.map((d) => (
        <Countdown {...d} key={d.imageName} />
      ))}
    </StyledSection>
  );
};

export default CountDowns;
